"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.david.description': 'Deep, soothing tone with kindness and sincerity.',
};
